"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_1 = require("@coreui/icons");
const icons_react_1 = __importDefault(require("@coreui/icons-react"));
const react_1 = require("@coreui/react");
const query_1 = require("@reduxjs/toolkit/query");
const react_2 = require("react");
const portal_api_1 = require("portal-api");
const utils_1 = require("utils");
const utils_2 = require("../utils");
function LocationStatus({ locationId, locationName, isDisabled, }) {
    const userEmail = (0, utils_2.getUserEmail)();
    const [modalVisible, setModalVisible] = (0, react_2.useState)(false);
    const [errorMessage, setErrorMessage] = (0, react_2.useState)(null);
    const [action, setAction] = (0, react_2.useState)(undefined);
    const [reason, setReason] = (0, react_2.useState)(undefined);
    const actionButtonClicked = (action) => {
        setAction(action);
        setModalVisible(true);
    };
    const { data, refetch } = (0, portal_api_1.useGetInternalPortalV1LocationStatusesLocationIdCurrentStatusQuery)(locationId
        ? {
            locationId: Number(locationId),
        }
        : query_1.skipToken);
    const [closeLocation, { isLoading: isLoadingClose }] = (0, portal_api_1.usePostInternalPortalV1LocationStatusesLocationIdCloseLocationMutation)();
    const [suspendLocation, { isLoading: isLoadingSuspend }] = (0, portal_api_1.usePostInternalPortalV1LocationStatusesLocationIdSuspendLocationMutation)();
    const [reopenLocation, { isLoading: isLoadingReopen }] = (0, portal_api_1.usePostInternalPortalV1LocationStatusesLocationIdReopenLocationMutation)();
    const [LocationStatusData, setLocationStatusData] = (0, react_2.useState)(null);
    const handleModalCancel = () => {
        setErrorMessage(null);
        setModalVisible(false);
    };
    const handleModalAccept = () => {
        updateLocationStatus().then((res) => {
            if (res.error) {
                setErrorMessage(res.error.data.error);
            }
            else {
                setModalVisible(false);
                refetch();
            }
        });
    };
    const loading = (0, react_2.useMemo)(() => {
        return isLoadingClose || isLoadingSuspend || isLoadingReopen;
    }, [isLoadingClose, isLoadingSuspend, isLoadingReopen]);
    const updateLocationStatus = () => {
        if (data == undefined) {
            return Promise.resolve({
                error: {
                    data: {
                        error: 'Location not found',
                    },
                },
            });
        }
        if (action === 'Close' && reason) {
            return closeLocation({
                locationId: locationId,
                body: { statusReason: reason, creatorEmail: userEmail },
            });
        }
        else if (action === 'Suspend' && reason) {
            return suspendLocation({
                locationId: locationId,
                body: { statusReason: reason, creatorEmail: userEmail },
            });
        }
        else if (action === 'Reopen') {
            return reopenLocation({
                locationId: locationId,
                body: {
                    reopenFrom: data.status,
                    statusReason: 'reopened',
                    creatorEmail: userEmail,
                },
            });
        }
        else {
            return Promise.resolve({
                error: {
                    data: {
                        error: 'Action not supported',
                    },
                },
            });
        }
    };
    const statusColor = (0, react_2.useCallback)(() => {
        const status = data?.status;
        if (status === 'active') {
            return 'success';
        }
        else if (status === 'closed') {
            return 'danger';
        }
        else if (status === 'suspended') {
            return 'warning';
        }
        else {
            return 'info';
        }
    }, [data]);
    (0, react_2.useEffect)(() => {
        if (data) {
            setLocationStatusData(data);
        }
    }, [data]);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: LocationStatusData ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(react_1.CCard, { className: "location-box box-stack applicant-info-container", children: [(0, jsx_runtime_1.jsx)(react_1.CCardTitle, { className: "w100", as: "h4", children: "Location Details" }), (0, jsx_runtime_1.jsxs)("div", { className: "pad-x-20", children: [(0, jsx_runtime_1.jsxs)("div", { className: "lender-display", children: [(0, jsx_runtime_1.jsx)("span", { className: "lender-name", children: "Status" }), (0, jsx_runtime_1.jsx)("div", { className: "status text-uppercase", children: (0, jsx_runtime_1.jsxs)(react_1.CBadge, { className: "m-t-10", color: `${statusColor()}`, style: { lineHeight: 2 }, children: [(0, jsx_runtime_1.jsx)(icons_react_1.default, { icon: data?.status !== 'active' ? icons_1.cilXCircle : icons_1.cilCheckCircle, height: 14 }), "\u00A0\u00A0", data?.status] }) })] }), (0, jsx_runtime_1.jsxs)("div", { className: "lender-display", children: [(0, jsx_runtime_1.jsx)("span", { className: "lender-name", children: "Status Reason" }), (0, jsx_runtime_1.jsx)("span", { children: data?.statusReason ? (0, utils_1.titleCase)(data?.statusReason) : 'N/A' })] })] }), (0, jsx_runtime_1.jsxs)("div", { className: "d-grid gap-2 col-12 mx-auto mt-5", children: [(data?.status == 'closed' || data?.status == 'suspended') && ((0, jsx_runtime_1.jsx)(react_1.CButton, { color: "primary", onClick: () => actionButtonClicked('Reopen'), disabled: isDisabled, children: "Reopen Location" })), data?.status == 'active' && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_1.CButton, { color: "primary", onClick: () => actionButtonClicked('Close'), disabled: isDisabled, children: "Close Location" }), (0, jsx_runtime_1.jsx)(react_1.CButton, { color: "secondary", onClick: () => actionButtonClicked('Suspend'), disabled: isDisabled, children: "Suspend Location" })] }))] })] }), (0, jsx_runtime_1.jsxs)(react_1.CModal, { visible: modalVisible, onClose: handleModalCancel, portal: false, children: [(0, jsx_runtime_1.jsxs)(react_1.CModalHeader, { children: ["Confirm \"", action, "\" Location "] }), (0, jsx_runtime_1.jsxs)(react_1.CModalBody, { children: [errorMessage && (0, jsx_runtime_1.jsx)(react_1.CAlert, { color: "danger", children: errorMessage }), "Are you sure you want to ", (0, jsx_runtime_1.jsx)("b", { children: action }), " ", locationName, " with locationId: ", locationId, "?", data?.status == 'active' && ((0, jsx_runtime_1.jsxs)(react_1.CFormSelect, { "aria-label": "Default select example", onChange: (e) => setReason(e.target.value), children: [' ', (0, jsx_runtime_1.jsxs)("option", { children: ["Please select the reason for ", action] }), (0, jsx_runtime_1.jsx)("option", { value: "ads_request", children: "Bread Request" }), (0, jsx_runtime_1.jsx)("option", { value: "location_request", children: "Location Request" }), (0, jsx_runtime_1.jsx)("option", { value: "alphaeon_request", children: "Alphaeon Request" }), (0, jsx_runtime_1.jsx)("option", { value: "fraud_check", children: "Fraud Check" })] }))] }), (0, jsx_runtime_1.jsxs)(react_1.CModalFooter, { children: [(0, jsx_runtime_1.jsx)(react_1.CButton, { color: "secondary", onClick: handleModalCancel, children: "Cancel" }), (0, jsx_runtime_1.jsxs)(react_1.CButton, { color: "primary", onClick: handleModalAccept, disabled: loading ||
                                        (data?.status == 'active' &&
                                            (!reason || reason.includes('Please select the reason'))), children: ["Accept ", loading && (0, jsx_runtime_1.jsx)(react_1.CSpinner, {})] })] })] })] })) : ((0, jsx_runtime_1.jsxs)("div", { className: "d-flex-center__column", children: [(0, jsx_runtime_1.jsx)(react_1.CSpinner, {}), (0, jsx_runtime_1.jsx)("div", { children: "Loading...." })] })) }));
}
exports.default = LocationStatus;
